import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-207ffc87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-dropdown__toggler" }
const _hoisted_2 = { class: "account-dropdown__photo" }
const _hoisted_3 = { class: "account-dropdown__caption" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "account-dropdown__icon icon-arrow-triangle--up-white" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-dropdown-menu__item-icon icon-cog--dark" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-dropdown-menu__item-icon icon-move-out--dark" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxAvatar = _resolveComponent("PxAvatar")!
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")!
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")!
  const _component_ElDropdown = _resolveComponent("ElDropdown")!

  return (_openBlock(), _createBlock(_component_ElDropdown, {
    class: _normalizeClass([{ 'is-open': _ctx.isMenuVisible }, "account-dropdown"]),
    trigger: "click",
    "popper-class": "account-dropdown-popper",
    onVisibleChange: _ctx.onVisibleChange
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_ElDropdownMenu, { class: "account-dropdown__menu" }, {
        default: _withCtx(() => [
          _createVNode(_component_ElDropdownItem, { onClick: _ctx.goToSettings }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t(`common.navigation.dropdownItems.account[${_ctx.userType}]`)), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ElDropdownItem, { onClick: _ctx.onClickLogout }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("common.navigation.dropdownItems.logout")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_PxAvatar, {
            loading: !_ctx.company,
            name: _ctx.companyName,
            photo: _ctx.companyLogo,
            size: 30
          }, null, 8, ["loading", "name", "photo"])
        ]),
        _createElementVNode("span", _hoisted_3, [
          (_ctx.$screen.xlUp)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.companyName), 1)
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_4
        ])
      ])
    ]),
    _: 1
  }, 8, ["class", "onVisibleChange"]))
}